import { useSelector } from 'react-redux';

export function useStaff () {
  return useSelector (state => state.staff);
}

export function useSelectedStaff () {
  return useSelector (state => state.staff?.selectedStaff);
}
